gsap.registerPlugin(Draggable);

function initAlbumMenu(albumMenu) {
  if (!albumMenu) return;
  if (albumMenu.dataset.initialized === "true") return;

  albumMenu.dataset.initialized = "true";

  const track = albumMenu.querySelector('[id^="nav-links-"]');
  const viewport = albumMenu.querySelector(".nav-viewport");
  const panel = albumMenu.querySelector(".nav-panel");
  const prevBtn = albumMenu.querySelector(".prev");
  const nextBtn = albumMenu.querySelector(".next");
  const navToggle = albumMenu.querySelector(".nav-toggle");

  if (!track || !viewport || !navToggle || !panel) return;

  const links = gsap.utils.toArray(track.querySelectorAll(".nav-link"));

  let currentIndex = 0;
  let positions = [];
  let maxX = 0;
  let draggableInstance = null;

  function updateMenuHeightVar() {
    const panelHeight = panel.offsetHeight;
    document.documentElement.style.setProperty(
      "--album-menu-height",
      `${panelHeight}px`,
    );
  }

  function toggleNav() {
    const isOpen = albumMenu.dataset.nav === "true";
    const nextState = isOpen ? "false" : "true";

    updateMenuHeightVar();

    albumMenu.dataset.nav = nextState;
    document.body.dataset.albumMenuOpen = nextState;
  }

  function calculatePositions() {
    positions = links.map((link) => -link.offsetLeft);

    const trackWidth = track.scrollWidth;
    const viewportWidth = viewport.offsetWidth;

    maxX = Math.min(0, viewportWidth - trackWidth);
    positions = positions.map((x) => Math.max(maxX, Math.min(0, x)));
  }

  function goToIndex(index) {
    currentIndex = Math.max(0, Math.min(index, links.length - 1));
    const targetX = positions[currentIndex] ?? 0;

    gsap.to(track, {
      x: targetX,
      duration: 0.5,
      ease: "power3.out",
    });
  }

  function nearestIndex(x) {
    let closestIndex = 0;
    let smallestDistance = Infinity;

    positions.forEach((pos, index) => {
      const distance = Math.abs(pos - x);
      if (distance < smallestDistance) {
        smallestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function initSlider() {
    updateMenuHeightVar();
    calculatePositions();

    if (draggableInstance) {
      draggableInstance.kill();
    }

    draggableInstance = Draggable.create(track, {
      type: "x",
      bounds: { minX: maxX, maxX: 0 },
      edgeResistance: 0.9,
      onDragEnd: function () {
        currentIndex = nearestIndex(this.x);
        goToIndex(currentIndex);
      },
    })[0];

    goToIndex(currentIndex);
  }

  prevBtn?.addEventListener("click", () => goToIndex(currentIndex - 1));
  nextBtn?.addEventListener("click", () => goToIndex(currentIndex + 1));
  navToggle.addEventListener("click", toggleNav);

  initSlider();
  window.addEventListener("resize", initSlider);
}

function initAllAlbumMenus(scope = document) {
  scope.querySelectorAll(".album-menu-section").forEach(initAlbumMenu);
}

document.addEventListener("DOMContentLoaded", () => {
  initAllAlbumMenus();
});

document.addEventListener("shopify:section:load", (event) => {
  initAllAlbumMenus(event.target);
});
